import { render, staticRenderFns } from "./Prueba.vue?vue&type=template&id=aab432ac&"
import script from "./Prueba.vue?vue&type=script&lang=js&"
export * from "./Prueba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports